import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import { connect } from 'react-redux';

import { fetchCustomers } from "reducers/customer/customerActions";


class CustomerTypeahead extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            useCache: false
        };
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    clearText() {
        this.refs.syncTypeAhead.getInstance().clear();
    }

    handleSearch = (query) => {
        this.setState({ isLoading: true });

        let promise = new Promise((resolve, reject) => {
            this.props.fetchCustomers(query, resolve, reject);
        });
        promise.then(() => {
            this.setState({
                isLoading: false
            });
        });
    }

    handleChange(customerSelected) {
        if (customerSelected === undefined) {
            customerSelected = null;
        }
        this.props.handleChange(customerSelected);
    }

    render() {
        return (
            <AsyncTypeahead
                {...this.state}
                disabled={this.props.disabled}
                bsSize={"small"}
                ref="syncTypeAhead"
                options={this.props.customers}
                labelKey="completeName"
                minLength={3}
                onSearch={this.handleSearch}
                placeholder="Busca un Cliente"
                onChange={(selected) => this.handleChange(selected[0])}
                renderMenuItemChildren={(option, props) => (
                    <div key={option.id}> {option.completeName} </div>
                )}
                selected={this.props.selection != null ? [this.props.selection] : null}
            />
        )
    }
}

const mapStateToProps = state => (
    {
        customers: state.customer.items
    }
)
export default connect(mapStateToProps, { fetchCustomers })(CustomerTypeahead)




// WEBPACK FOOTER //
// ./src/components/Typeaheads/CustomerTypeahead.jsx